import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import LandingPage from "./pages/LandingPage";
import CookieNotice from "./components/CookieNotice";
import TrackPageview from "./components/TrackPageview";
import ManageApplicationPage from "./pages/ManageApplicationPage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import StaticPage from "./pages/StaticPage";
import JobDetailPage from "./pages/JobDetailPage";
import { getToken } from "./lib/api";
import "@/App.css";

function ProtectedRoute({ children }) {
    return getToken() ? children : <Navigate to="/admin" replace />;
}

export default function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Toaster richColors position="top-center" />
                <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/admin" element={<AdminLogin />} />
                    <Route
                        path="/admin/dashboard"
                        element={
                            <ProtectedRoute>
                                <AdminDashboard />
                            </ProtectedRoute>
                        }
                    />
                    <Route path="/stelle/:slug" element={<JobDetailPage />} />
                    <Route path="/bewerbung/:token" element={<ManageApplicationPage />} />
                    <Route path="/impressum" element={<StaticPage pageKey="impressum" />} />
                    <Route path="/datenschutz" element={<StaticPage pageKey="datenschutz" />} />
                    <Route path="/kontakt" element={<StaticPage pageKey="kontakt" />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
                <CookieNotice />
                <TrackPageview />
            </BrowserRouter>
        </div>
    );
}
